import React from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'

import DashboardLayout from '../DashboardLayout'
import ProfileForm from '../../../Component/ProfileForm'
import Layout from '../Layout'

const Profile = (props) => {
    return (
        <Layout props={props}>
            <DashboardLayout title="My Account">
                <Container className="dashboard-wrapper">
                    <Grid container spacing={3}>
                        <ProfileForm />
                    </Grid>
                </Container>
            </DashboardLayout>
        </Layout>
    )
}

export default Profile
